import MobileDevice from '@/mixins/MobileDevice.js'
export default {
  mixins: [MobileDevice],
  methods: {
    videoPositioning () {
      setTimeout(() => {
        this.window.width = window.innerWidth
        this.window.height = window.innerHeight
        if (this.elementVideo) {
          this.getVideoWidth((elementWidth) => {
            let videoheight = elementWidth / 1.777
            if (this.fullScreenActive) {
              if (videoheight > window.innerHeight) {
                this.elementVideo.style.marginTop = -(videoheight - window.innerHeight) / 2 + 'px'
                this.elementVideo.style.height = videoheight + 'px'
                let difference = videoheight - window.innerHeight
                this.marginBottom = difference / 2 + 'px'
              } else {
                this.elementVideo.style.marginTop = (this.window.height - videoheight) / 2 + 'px'
                this.elementVideo.style.marginLeft = ''
                this.elementVideo.style.width = ''
                this.marginBottom = ''
                videoheight = elementWidth / 1.777
                this.elementVideo.style.height = videoheight + 'px'
              }
            } else {
              this.elementVideo.style.width = ''
              this.marginBottom = ''
              let videoheight = elementWidth / 1.777
              this.elementVideo.style.height = videoheight + 'px'

              this.elementVideo.style.marginTop = ''
              this.elementVideo.style.marginLeft = ''
            }
          })
        }
      })
    },
    getVideoWidth (callback) {
      setTimeout(() => {
        if (callback) {
          if (this.isMobileDevice() || this.window.width < 1000) {
            callback(this.window.width)
          } else {
            if (this.elementVideo.offsetWidth >= 320) {
              callback(this.elementVideo.offsetWidth)
            } else {
              this.getVideoWidth(callback)
            }
          }
        }
      }, 500)
    }
  }
}
